import Icon from './Icon';

const Add = (props) => (
  <Icon
    {...props}
    path="M63.333 37.5h-20.833v-20.833c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 20.833h-20.833c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5v0h20.833v20.833c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v0-20.833h20.833c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5v0z"
  />
);

export default Add;
